import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { sendApiData_ } from "store/services/commonService";


const SendApiModal = ({ show, handleClose, editData, api, email }) => {
    console.log("api======>", api)
    const dispatch = useDispatch();
    const [showBtn, setShowBtn] = useState(false);

    const handleSubmit = async () => {
        try {
            setShowBtn(true);
            const query = {
                url: "sendTradingDocument",
                tradingApiKey: api,
                email: email,
            };
            await dispatch(sendApiData_(query));
            handleClose(); // Close modal on success
        } catch (err) {
            if (err.name === "ValidationError") {
                console.error(err);
            } else {
                console.error(err);
            }
        } finally {
            setShowBtn(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={() => {
                handleClose();
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Send Private Trading api</Modal.Title>
            </Modal.Header>
            <hr />
            <Modal.Body>
                <div className="form-group">
                    <label htmlFor="apiInput">Api*</label>
                    <input
                        type="text"
                        className="form-control bg-white"
                        id="apiInput"
                        placeholder="Enter Api"
                        value={api}
                        disabled
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={showBtn}
                    className="btn btn-gradient-primary me-2"
                >
                    {showBtn ? "Wait..." : "Send"}
                </button>
                <button
                    type="button"
                    className="btn btn-lg btn-outline-secondary"
                    onClick={handleClose}
                >
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default SendApiModal;
